import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _classPrivateFieldGet from '@babel/runtime-corejs3/helpers/classPrivateFieldGet';
import _classPrivateFieldSet from '@babel/runtime-corejs3/helpers/classPrivateFieldSet';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js/instance/index-of';
import _spliceInstanceProperty from '@babel/runtime-corejs3/core-js/instance/splice';
import _WeakMap from '@babel/runtime-corejs3/core-js/weak-map';

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

var _listener = /*#__PURE__*/new _WeakMap();

var Topic = /*#__PURE__*/function () {
  function Topic() {
    _classCallCheck(this, Topic);

    _classPrivateFieldInitSpec(this, _listener, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(this, _listener, []);
  }

  _createClass(Topic, [{
    key: "register",
    value: function register(listener) {
      _classPrivateFieldGet(this, _listener).push(listener);
    }
  }, {
    key: "unregister",
    value: function unregister(listener) {
      var _context;

      var listerIdx = _indexOfInstanceProperty(_context = _classPrivateFieldGet(this, _listener)).call(_context, listener);

      if (listerIdx >= 0) {
        var _context2;

        _spliceInstanceProperty(_context2 = _classPrivateFieldGet(this, _listener)).call(_context2, listerIdx, 1);
      }
    }
  }, {
    key: "notify",
    value: function notify(message) {
      return _classPrivateFieldGet(this, _listener).forEach(function (listener) {
        return listener(message);
      });
    }
  }]);

  return Topic;
}();

export { Topic };
